<label *ngIf="label != null && label != '' && showLabel" class="sumax-label mb-0 p-0">{{label}}<span *ngIf="required"
		[class.text-danger]="controls?.errors != null"> *</span></label>
<div [class.input-icon]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted"
	[class.right]="controls?.errors != null && (controls?.dirty || controls?.touched) && submitted">
	<!-- tooltip-message es el icono de error -->
	
	<tooltip-message [label]="label" [controls]="controls" [validatorMessage]="validatorMessage"
	[tooltipMessage]="tooltipMessage" [submitted]="submitted"></tooltip-message>
	<div class="input-group mr-2">
		<input name="input" type="text" class="form-control form-control-sm" [disabled]="true"
			[ngModel]="input | date:inputDatetimeFormat">
		<input class="form-control form-control-sm" container="body" [readonly]="true" placeholder="dd/mm/yyyy"
			name="dp" [(ngModel)]="date" (ngModelChange)="onModelDateChange($event)" [autoClose]="'outside'" (dateSelect)="onDateSelect($event)"
			ngbDatepicker [footerTemplate]="footerTemplate" #d="ngbDatepicker">
		<div class="input-group-append">
			<button #btnOpen class="btn btn-info p-0 rounded-0" [disabled]="isDisabled || readonly" (click)="open(d)"
				(keyup.ArrowLeft)="goBack()" (keyup.ArrowRight)="btnClean.focus()" type="button">
				<!-- <mat-icon class="text-white pt-1" style="font-size: 18px;" [matTooltip]="'Calendario'" matTooltipClass="bg-info">calendar_today</mat-icon> -->
				<i aria-hidden="true" class="fa fa-calendar text-light px-1"></i>
			</button>
			<button #btnClean class="btn btn-danger p-0 rounded-0 limpiar" [disabled]="isDisabled || readonly"
				(click)="limpiar()" (keyup.ArrowLeft)="btnOpen.focus()" (keyup.ArrowRight)="goNext()" type="button">
				<!-- <mat-icon class="text-white pt-1" style="font-size: 18px;" [matTooltip]="'Limpiar'" matTooltipClass="bg-danger">close</mat-icon> -->
				<i aria-hidden="true" class="fa fa-times px-1 text-light"></i>
			</button>
		</div>
	</div>
</div>

<ng-template #footerTemplate>
	<hr class="my-0">
	<ngb-timepicker #tp [(ngModel)]="time" name="timepicker" (ngModelChange)="onModelDateChange($event)" (focusout)="focusOut($event)" >
	</ngb-timepicker>
</ng-template>
<!-- error-message es el mansaje que aparece abajo del componente -->
<error-message [label]="label" [controls]="controls" [validatorMessage]="validatorMessage"
	[tooltipMessage]="tooltipMessage" [submitted]="submitted"></error-message>